import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

// Frontend defense-in-depth only; backend must retain its HTTP 423 write gate.
// READ_ONLY is intentionally not enabled by this source change.
api.interceptors.request.use((config) => {
  if (process.env.REACT_APP_SG_PRELIVE_MODE === "READ_ONLY") {
    const method = (config.method || "get").toLowerCase();
    if (!["get", "head", "options"].includes(method)) {
      return Promise.reject(new Error("SG_READ_ONLY_WRITE_BLOCKED"));
    }
  }
  return config;
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("access_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;

  // Request Safety V1: do not force a unique URL for every GET. The old blanket
  // `_t=Date.now()` disabled all browser/proxy reuse and amplified repeated component
  // fetches. Callers that truly require a one-off cache-bust can opt in explicitly.
  if ((config.method || "get").toLowerCase() === "get" && config.cacheBust === true) {
    config.params = { ...(config.params || {}), _t: Date.now() };
  }
  if (Object.prototype.hasOwnProperty.call(config, "cacheBust")) delete config.cacheBust;

  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Terjadi kesalahan. Coba lagi.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.message === "string") return detail.message;
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
